import styled from 'styled-components';
import {
  MOBILE_BREAKPOINT_IN_PX,
  TABLET_BREAKPOINT_IN_PX,
  LAPTOP_BREAKPOINT_IN_PX,
} from '../../constants';

const Description = styled.div`
  margin-top: 20px;
  margin-bottom: 40px;

  @media screen and (max-width: ${LAPTOP_BREAKPOINT_IN_PX}px) {
    margin-top: 15px;
    margin-bottom: 30px;
  }

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    margin-top: 10px;
    margin-bottom: 15px;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    margin-left: 20px;
    margin-right: 20px;
  }
`;

export default Description;
